import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class PendenciasService {

  constructor(
    private http: HttpClient
  ) { }

  getPendencias(contaId) {
    return this.http
      .get(urls.apiBase + '/Pendencias/ObterTodos?referenciaId=' + contaId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/pendencias/pendencias.service.ts